module.exports = __webpack_public_path__ + "static/img/250529TW.3dd0541.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/250529TW.jpg
// module id = iI+0
// module chunks = 1